<div class="ui-g page-header" *ngIf="headerHidden">
  <div class="ui-g-12 ui-md-6 ui-lg-6">
    <h1 #input tabindex="0" id="input" class="page-title">{{headerStr}}</h1>
  </div>
  <!-- <div class="ui-g-12 ui-md-6 ui-lg-6">
    <div  class="bread-crumbs">
      <li class="bread-item" *ngFor='let bread of breadCrumbArray; let index=index'>  
        <a *ngIf="bread.name.length" href="{{bread.url}}"> &nbsp;{{bread.name}}</a> <label *ngIf="(index+1)!==breadCrumbArray.length"> > </label></li>
    </div>
  </div> -->
</div>
<p-growl [value]="message"></p-growl>